import type {Directive} from "vue";
import type {FormEnvironment} from "../Types";
import {addPreviewListeners, removePreviewListeners} from "@/utils/WebPreview.ts";
export {previewKey} from "@/utils/WebPreview.ts";


/**
 * This is Vue plugin providing v-preview
 */
export default function (env: FormEnvironment):Directive {

    return {
        mounted(el:HTMLElement, binding, vnode, prevVnode) {
            const key = binding.value == null ? "" : binding.value;
            el.dataset.preview = key;
            if (key) {
				addPreviewListeners(el);
            }
        },

        updated(el:HTMLElement, binding, vnode, prevVnode) {
            const oldKey = el.dataset.preview;
            const key = binding.value == null ? "" : binding.value;
            el.dataset.preview = key;
            if (oldKey) {
                if (!key) removePreviewListeners(el);
            } else {
                if (key) addPreviewListeners(el);
            }
        },

        beforeUnmount(el:HTMLElement, binding, vnode, prevVnode) {
            if (el.dataset.preview) {
				removePreviewListeners(el);
            }
        }
    };
};
